import { render } from "./AppStoreButton.vue?vue&type=template&id=494dad28"
import script from "./AppStoreButton.vue?vue&type=script&lang=js"
export * from "./AppStoreButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__